import styled from "styled-components";

export const MainContent = styled.div`
  width: 90%;
  margin: 0 auto;
`;

export const Nav = styled.nav`
  border-bottom: 1px solid rgb(223, 225, 228);
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: center;

  .active {
    color: black;
    font-weight: bold;
    position: relative;
  }

  .active::after {
    content: "";
    position: absolute;
    display: block;
    background: #0071bc;
    height: 3.5px;
    width: 100%;
    bottom: calc(0% - 2px);
    left: 0;
  }

  li {
    padding: 0;
    list-style-type: none;
  }
  li + li {
    margin-left: 2rem;
  }

  li a {
    text-decoration: none;
    color: initial;
    display: inline-block;
    transition: 200ms ease-out;
  }
  li a:hover {
    opacity: 0.5;
  }
`;

export const Table = styled.div`
  h2 {
    font-size: 2.5rem;
    margin-bottom: 2rem;
    position: relative;
  }
  h2::after {
    content: "";
    position: absolute;
    display: inline-block;
    height: 3px;
    width: 5%;
    top: 120%;
    left: 0;
    background: #0071bc;
  }
`;

export const TableButton = {
  marginLeft: "3rem",
  background: "#c73c3cdb",
};

export const applicantsTable = {
  display: "block",
  marginTop: "2rem",
};

export const savedTable = {
  display: "none",
  marginTop: "2rem",
};

export const contactedTable = {
  display: "none",
  marginTop: "2rem",
};
